import { render, staticRenderFns } from "./dxjt.vue?vue&type=template&id=2088a92f"
import script from "./dxjt.vue?vue&type=script&lang=js"
export * from "./dxjt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports